import { render } from "./a-tasks-table.vue?vue&type=template&id=753dec0e&scoped=true"
import script from "./a-tasks-table.vue?vue&type=script&lang=js"
export * from "./a-tasks-table.vue?vue&type=script&lang=js"

import "./a-tasks-table.vue?vue&type=style&index=0&id=753dec0e&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753dec0e"]])

export default __exports__